import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Fade from '@mui/material/Fade'
import {useDrag} from 'react-dnd'
import {faCaretDown} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../context'
import {deletePlan} from '../../context/post'
import confirmDialog from '../confirm-dialog'

import { defaultDates, planLink } from 'planning/navigation'

import './event.styl'

function EventMenu({planId, context, title, defaultDate}) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
    event.stopPropagation()
  }

  const handleClose = event => {
    setAnchorEl(null)
    event.stopPropagation()
  }

  const handleDuplicate = event => {
    handleClose(event)
    context.navigate({view: context.view, planId}, '/:languageId/:role/:page/:view/duplicate/:planId', {preserveQuery: true})
  }

  const handlePreview = event => {
    handleClose(event)
    planLink(context, planId, defaultDate, 'preview')
  }

  const handleEdit = event => {
    handleClose(event)
    planLink(context, planId, defaultDate)
  }

  const handleDelete = event => {
      handleClose(event)
      confirmDialog({
        className: 'delete-plan',
        translate: context.translate,
        children: (
          <div className="message">
            <div className="question">
              {context.translate('confirm_delete_item')}
            </div>
            <div className="title">
              {title}
            </div>
          </div>
        ),
        onConfirm: () => {
          deletePlan(planId).then(() => {
            const planUpdates = context.planUpdates + 1
            context.setState({planUpdates})
          })
        }
      })
  }

  return (
    <div className="event-menu-button">
      <Button aria-controls="event-menu" aria-haspopup="true" onClick={handleClick}>
        <FontAwesomeIcon icon={faCaretDown} />
      </Button>
      <Menu
        className="event-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handlePreview}>
          <Text id="preview_title" />
        </MenuItem>
        <MenuItem onClick={handleEdit}>
          <Text id="edit_label" />
        </MenuItem>
        <MenuItem onClick={handleDuplicate}>
          <Text id="duplicate" />
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <Text id="delete_label" />
        </MenuItem>
      </Menu>
    </div>
  )
}

export default function Event (props) {
  const {id: planId, title, subject: subjectId, date, defaultDate} = props
  const [{ opacity }, dragRef] = useDrag({
    item: { type: 'event', id: props.id },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.5 : 1,
    })
  })
  const isFirst =  moment(props.start).format('YYYY-MM-DD') == props.day

  return (<Consumer>{ context => {
    const {subjects} = context
    const subject = subjects.find(subject => subject.id == subjectId) || subjects[0]
    return (

    <div ref={dragRef}
        className="event"
        style={{
          opacity,
          color: subject.textColor,
          backgroundColor: subject.color,
        }}
      >
        <label title={title}>{title}</label>
        <div className="flex spacer" />
        {isFirst && (<EventMenu {...{planId, title, context, date, defaultDate}}/>)}
      </div>)
  }}</Consumer>)
}
